import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { CreateEmployeeForm } from '@/features/employee'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/users/employees/create')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Создание сотрудника')}>
      <CreateEmployeeForm onClose={close} />
    </Offcanvas>
  )
}
